/**
 * This is a dependency container for all singletons and other objects that need to be shared between modules.
 *
 * Singletons are registered here, and then injected into the modules that need them.
 */
export class Container {
    static instance_;
    static getInstance() {
        this.instance_ ??= new Container();
        return this.instance_;
    }
    constructor() {
        // private constructor to prevent direct instantiation
    }
    registerSingleton(name, singleton) {
        this[name] = singleton;
    }
    get(name) {
        return this[name];
    }
}
